export const services = [
  {
    id: 1,
    icon: 'ri-auction-line',
    title: 'Daños y perjuicios',
    items: [
      'Accidentes de tránsito',
      'Malapraxis',
      'Incumplimiento obligacional',
      'Fincas dañadas',
    ],
  },
  {
    id: 2,
    icon: 'ri-heart-3-line',
    title: 'Familia',
    items: [
      'Cuota alimentaria',
      'Divorcio',
      'Sucesiones',
      'Violencia familiar',
    ],
  },
  {
    id: 3,
    icon: 'ri-briefcase-4-line',
    title: 'Laboral',
    items: [
      'Accidentes laborales',
      'Enfermedades profesionales',
      'Despido',
    ],
  },
];

export const team = [
  {
    id: 1,
    name: 'Dr. Gou Joel',
    role: 'M.P 1-39861',
    specialty: 'Derecho Corporativo',
    bio: 'Más de 30 años liderando operaciones corporativas de primer nivel. Fundador del despacho en 1998.',
    education: 'Universidad Complutense de Madrid • LL.M. Harvard Law School',
    image: 'https://storage.readdy-site.link/project_files/732df27f-b232-4dc5-8c9d-bb28540a6b17/e764245d-5fba-4a18-a3a1-2646ab1cded8_compressed_WhatsApp-Image-2026-07-01-at-10.04.14.webp',
  },
  {
    id: 2,
    name: 'Dra. Amigo Valentina',
    role: 'M.P 1-43598',
    specialty: 'Derecho Fiscal',
    bio: 'Especialista en fiscalidad internacional con una trayectoria brillante en los despachos más prestigiosos de Europa.',
    education: 'Universidad de Barcelona • Máster en Tributación IE Law School',
    image: 'https://storage.readdy-site.link/project_files/732df27f-b232-4dc5-8c9d-bb28540a6b17/c53a5b08-389b-4e30-8b1b-3de741275de1_compressed_WhatsApp-Image-2026-07-01-at-10.04.14-1.webp',
  },
];

export const teamMembers = [
  {
    name: 'Dña. Laura Castellón',
    role: 'Abogada Senior',
    specialty: 'Derecho Laboral',
    bio: 'Especialista en derecho laboral y seguridad social con amplia experiencia en tribunales.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20female%20lawyer%20in%20her%20late%2030s%20with%20brown%20wavy%20hair%20wearing%20a%20navy%20blue%20blazer%20with%20white%20blouse%20professional%20warm%20smile%20soft%20natural%20lighting%20cream%20background%20editorial%20portrait%20photography%20elegant%20and%20approachable%20composition&width=300&height=300&seq=team-04&orientation=squarish',
  },
  {
    name: 'D. Miguel Ángel Torres',
    role: 'Abogado Senior',
    specialty: 'Derecho Inmobiliario',
    bio: 'Experto en operaciones inmobiliarias complejas y derecho urbanístico.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20lawyer%20in%20his%20mid%2040s%20with%20short%20graying%20hair%20clean%20shaven%20wearing%20a%20light%20gray%20suit%20with%20blue%20tie%20serious%20professional%20expression%20natural%20side%20lighting%20cream%20background%20editorial%20portrait%20photography%20confident%20composition&width=300&height=300&seq=team-05&orientation=squarish',
  },
];

export const testimonials = [
  {
    id: 1,
    quote: 'Solucionan rápido. Excelente Valentina.',
    author: 'Nacho Rossa',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%20early%2030s%20with%20short%20dark%20hair%20light%20stubble%20wearing%20a%20casual%20white%20shirt%20warm%20genuine%20smile%20natural%20daylight%20soft%20focus%20background%20cream%20tone%20editorial%20portrait%20photography%20approachable%20expression&width=700&height=900&seq=testimonial-gm-01&orientation=portrait',
  },
  {
    id: 2,
    quote: 'Excelentes profesionales! Muy buen acompañamiento y seguimiento. Recomiendo.',
    author: 'Maria Sol Nasi',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20her%20mid%2030s%20with%20long%20dark%20hair%20subtle%20makeup%20wearing%20a%20beige%20blouse%20warm%20friendly%20smile%20soft%20window%20lighting%20cream%20background%20editorial%20portrait%20photography%20natural%20and%20confident%20expression&width=700&height=900&seq=testimonial-gm-02&orientation=portrait',
  },
  {
    id: 3,
    quote: 'Excelente profesional! Siempre brindando soluciones.',
    author: 'Jeremias Cabrera',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%20late%2020s%20with%20short%20brown%20hair%20clean%20shaven%20wearing%20a%20navy%20polo%20shirt%20confident%20smile%20natural%20outdoor%20lighting%20soft%20bokeh%20background%20cream%20neutral%20tone%20editorial%20portrait%20photography%20friendly%20expression&width=700&height=900&seq=testimonial-gm-03&orientation=portrait',
  },
  {
    id: 4,
    quote: 'Muy bueno el asesoramiento que me dieron, gracias.',
    author: 'Vitto Dionisio',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%20mid%2030s%20with%20dark%20curly%20hair%20light%20beard%20wearing%20a%20light%20gray%20button%20up%20shirt%20genuine%20warm%20smile%20soft%20studio%20lighting%20cream%20background%20editorial%20portrait%20photography%20relaxed%20and%20approachable%20expression&width=700&height=900&seq=testimonial-gm-04&orientation=portrait',
  },
  {
    id: 5,
    quote: 'Me ayudaron durante todo el proceso. Muy atento y amable a toda hora cualquier día a la semana.',
    author: 'Juan Zartarian',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%20early%2040s%20with%20short%20graying%20hair%20clean%20shaven%20wearing%20a%20white%20dress%20shirt%20with%20subtle%20smile%20soft%20warm%20lighting%20cream%20background%20editorial%20portrait%20photography%20trustworthy%20and%20calm%20expression&width=700&height=900&seq=testimonial-gm-05&orientation=portrait',
  },
  {
    id: 6,
    quote: 'Excelente atención! Muy profesionales y resolutivos!!',
    author: 'Eze De La Torre',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%20late%2030s%20with%20styled%20dark%20hair%20five%20oclock%20shadow%20wearing%20a%20casual%20blazer%20over%20white%20tshirt%20warm%20smile%20natural%20light%20cream%20background%20editorial%20portrait%20photography%20energetic%20and%20friendly%20expression&width=700&height=900&seq=testimonial-gm-06&orientation=portrait',
  },
  {
    id: 7,
    quote: 'Gran profesional y ser humano. Gracias Dr. Gou!!',
    author: 'Jose Mariano Piatti',
    role: 'Cliente • Google Maps',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%20early%2050s%20with%20distinguished%20salt%20and%20pepper%20hair%20warm%20genuine%20smile%20wearing%20a%20light%20blue%20dress%20shirt%20soft%20studio%20lighting%20cream%20background%20editorial%20portrait%20photography%20kind%20and%20sincere%20expression&width=700&height=900&seq=testimonial-gm-07&orientation=portrait',
  },
  {
    id: 8,
    quote: 'Me ayuda con todo lo referido a mi Consultora.',
    author: 'Uriel Gou',
    role: 'Cliente • Google Maps',
    rating: 5,
  },
];